export const port = process.env.PORT || 3000;

export default {
  enableDevTools: true,
  api: {
    API_BASE:
      'https://he4tcnb2ozsxe43jn5xc6mjoga5g233dnnsxeltqojuxg3jopfwwy.prism.stoplight.io',
    // API URL to be used in the client-side code
    clientUrl: process.env.API_CLIENT_URL || '',
    // API URL to be used in the server-side code
    serverUrl:
      process.env.API_SERVER_URL ||
      `http://localhost:${process.env.PORT || 3000}`,
  },
  analytics: {
    google: {
      trackingId: process.env.GOOGLE_TRACKING_ID || 'UA-XXXXX-X',
    },
  },
  localStorageId: 'nf-react-standard',
  DEFAULT_LOCALE: 'en',
  DEFAULT_LOCALE_DATE: 'nl',
  DEFAULT_CURRENCY: 'EUR',
  SENTRY: 'https://a1a0667f59d541d1a25257f632a78640@sentry.io/1292956',
};



// WEBPACK FOOTER //
// /opt/build/repo/src/app/config/config.production.js